import React from 'react';
import { Modal } from "react-bootstrap";

import peoplePng from 'assets/images/business_1.png';

import {
  Container,
  Header,
  Title,
  CloseIcon,
  Content,
  ContentImg,
  ContentInfos,
  ContentButtons,
  Button,
} from "./styles";

const BannerDigital = ({ onClose, show }) => {
  return (
    <Modal
      show={show}
      onHide={onClose}
      size="lg"
      animation={false}
      centered
    >
      <Container>
        <Header>
          <CloseIcon title="Fechar" className="mdi mdi-close" onClick={onClose} />
        </Header>
        <Content>
          <ContentImg src={peoplePng} />
          <ContentInfos>
            <Title>Conta de gás 100% digital: <span>mais prática para você, mais sustentável para o planeta!</span></Title>

            <ContentButtons>
              <Button
                to={{
                  pathname: `/minha-unidade`,
                }}
              >
                Cadastre débito automático e fatura digital
              </Button>
            </ContentButtons>
          </ContentInfos>
        </Content>
      </Container>
    </Modal>
  );
};

export default BannerDigital;
